export default [
  {
    action: 'all',
    label: 'All',
  },
  {
    action: 'business',
    label: 'Business Contact',
  },
  {
    action: 'team',
    label: 'Pepper Team',
  },
];
